import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellFolderSizeS from './IconWellFolder_size_s';

const props: CreateIconArguments = {
  l: IconWellFolderSizeS,
  m: IconWellFolderSizeS,
  s: IconWellFolderSizeS,
  xs: IconWellFolderSizeS,
  name: 'IconWellFolder',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
